module.exports = __webpack_public_path__ + "static/img/camp3.7663e99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/camp3.jpg
// module id = zu4r
// module chunks = 0